import { MESApiService } from "@dexteel/mesf-core";

export const getTundishShrouds = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[CAS].[GetTundishShrouds]", []);
};
